import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3d92a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "branch" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"leftSwap\" data-v-c3d92a04><div class=\"textBox\" data-v-c3d92a04><i class=\"circle\" data-v-c3d92a04></i><div class=\"inBox\" data-v-c3d92a04>治疗前</div></div><div class=\"textBox\" data-v-c3d92a04><i class=\"circle\" data-v-c3d92a04></i><div class=\"inBox\" data-v-c3d92a04>治疗一周后</div></div><div class=\"textBox\" data-v-c3d92a04><i class=\"circle\" data-v-c3d92a04></i><div class=\"inBox\" data-v-c3d92a04>调整治疗方案</div></div><div class=\"textBox\" data-v-c3d92a04><i class=\"circle\" data-v-c3d92a04></i><div class=\"inBox\" data-v-c3d92a04>治疗两周后</div></div></div>", 1)
const _hoisted_4 = { class: "rightSwap" }
const _hoisted_5 = { class: "boxWrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallText" }, "四肢严重渗出，瘙痒难耐", -1))
const _hoisted_7 = { class: "bottomWarp" }
const _hoisted_8 = { class: "leftBox" }
const _hoisted_9 = { class: "boxWrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallText" }, "渗出好转，黄痂减少，夜间瘙痒缓解", -1))
const _hoisted_11 = { class: "bottomWarp" }
const _hoisted_12 = { class: "leftBox" }
const _hoisted_13 = { class: "boxWrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallText" }, " 停用莫匹罗星软膏，四肢严重处糠酸米米松软膏封包，并加强保湿，一周后复诊 ", -1))
const _hoisted_15 = { class: "bottomWarp" }
const _hoisted_16 = { class: "leftBox" }
const _hoisted_17 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}
const _hoisted_18 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.1333rem",
        height: ".6667rem",
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              width: "2.3333rem",
              height: "3.1067rem",
              src: require('../assets/x1.jpg')
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              width: "2.3333rem",
              height: "3.1067rem",
              src: require('../assets/x2.jpg')
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_van_image, {
              width: "2.3333rem",
              height: "3.1067rem",
              src: require('../assets/x3.jpg')
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              width: "2.3333rem",
              height: "3.1067rem",
              src: require('../assets/x4.jpg')
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_van_image, {
              width: "2.3333rem",
              height: "3.1067rem",
              src: require('../assets/x5.jpg')
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              width: "2.3333rem",
              height: "3.1067rem",
              src: require('../assets/x6.jpg')
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_van_image, {
          onClick: $options.showPopup,
          width: "2.5733rem",
          height: "2.5733rem",
          src: require('../assets/jixu.png')
        }, null, 8, ["onClick", "src"]),
        _createVNode(_component_van_image, {
          class: "finger",
          width: "1.28rem",
          height: "1.28rem",
          src: require('../assets/dong.gif')
        }, null, 8, ["src"])
      ]),
      _createVNode(_component_van_popup, {
        show: $data.show,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
      }, {
        default: _withCtx(() => [
          ($data.flag)
            ? (_openBlock(), _createBlock(_component_medical, {
                key: 0,
                onOnChanged: $options.updateChanged,
                postaimqus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus"]))
            : _createCommentVNode("", true),
          (!$data.flag)
            ? (_openBlock(), _createBlock(_component_medical, {
                key: 1,
                onOnChanged: $options.updateChanged,
                postaimqus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createVNode(_component_toNav, { menu: 4 })
  ], 64))
}